import { cn } from '../../lib/cn';
import { Card } from '../ui';

type Props = {
  standards?: string[];
  className?: string;
};

export function AccessibilityChecklist({ standards, className }: Props) {
  const items = standards ?? [
    'WCAG 2.2 AA minimum contrast',
    'Keyboard navigation on all flows',
    'Logical focus order',
    'Screen reader ARIA labels',
    'Reduced motion support',
    '44px minimum touch targets',
    'Color-independent status indicators',
  ];

  return (
    <Card className={cn(className)} padding="sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Accessibility Checklist</p>
      <ul className="mt-3 space-y-2">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-2 text-sm text-slate-700 dark:text-slate-300">
            <span className="mt-0.5 text-success-600" aria-hidden="true">✓</span>
            {item}
          </li>
        ))}
      </ul>
    </Card>
  );
}
